import React from "react";
import "./styles.css";

const WHATSAPP_URL = "https://wa.me/918085206562?text=Hello%20Edushala%2C%20I%20would%20like%20to%20make%20an%20enquiry.";

function IOSComingSoon() {
  return (
    <main className="ios-coming-soon">
      <div className="ios-orb ios-orb--one" />
      <div className="ios-orb ios-orb--two" />
      <section className="ios-coming-soon__card" aria-labelledby="coming-soon-title">
        <div className="ios-coming-soon__brand"><img src={require("assets/images/edushala.png")} alt="Edushala" /></div>
        <div className="ios-coming-soon__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.79 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.1l0-.01zM12.03 7.25C11.88 5.02 13.69 3.18 15.77 3c.29 2.58-2.34 4.5-3.74 4.25z" /></svg>
        </div>
        <p className="ios-coming-soon__eyebrow">Edushala for iOS</p>
        <h1 id="coming-soon-title">Coming Soon</h1>
        <p className="ios-coming-soon__copy">We&apos;re crafting a delightful learning experience for your iPhone. The Edushala iOS app will be with you soon.</p>
        <div className="ios-coming-soon__divider" />
        <p className="ios-coming-soon__enquiry">Have a question or want to make an enquiry?</p>
        <a className="ios-coming-soon__whatsapp" href={WHATSAPP_URL}>
          <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16.04 3A12.9 12.9 0 0 0 5.1 22.73L3.26 29l6.43-1.69A12.94 12.94 0 1 0 16.04 3Zm0 23.68c-2.1 0-4.15-.57-5.93-1.65l-.43-.26-3.81 1 1.02-3.72-.28-.44a10.72 10.72 0 1 1 9.43 5.07Zm5.88-8.03c-.32-.16-1.9-.94-2.2-1.05-.29-.11-.5-.16-.72.16-.21.32-.83 1.05-1.02 1.26-.19.22-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59a9.64 9.64 0 0 1-1.78-2.21c-.19-.32-.02-.49.14-.65.15-.14.32-.37.48-.56.16-.18.22-.32.32-.53.11-.21.06-.4-.02-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.1-1.12 2.67s1.15 3.1 1.31 3.31c.16.22 2.25 3.44 5.46 4.83.76.33 1.36.52 1.82.67.77.24 1.46.21 2.01.13.61-.09 1.9-.78 2.17-1.53.26-.75.26-1.4.18-1.53-.08-.14-.29-.22-.61-.38Z" /></svg>
          Enquire on WhatsApp
        </a>
        <p className="ios-coming-soon__number">+91 80852 06562</p>
      </section>
    </main>
  );
}

export default IOSComingSoon;
